var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgress2Line(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 10.0013C1.66675 14.6036 5.39771 18.3346 10.0001 18.3346C14.6024 18.3346 18.3334 14.6036 18.3334 10.0013C18.3334 5.39893 14.6024 1.66797 10.0001 1.66797C5.39771 1.66797 1.66675 5.39893 1.66675 10.0013ZM16.6667 10.0013C16.6667 13.6832 13.682 16.668 10.0001 16.668C6.31818 16.668 3.33341 13.6832 3.33341 10.0013C3.33341 6.3194 6.31818 3.33464 10.0001 3.33464C13.682 3.33464 16.6667 6.3194 16.6667 10.0013ZM10.0001 10.0013V5.0013C12.7615 5.0013 15.0001 7.23988 15.0001 10.0013H10.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress2Line);
export default __webpack_public_path__ + "static/media/progress-2-line.2e2f201adac232ec352056ff2acf6f12.svg";
export { ForwardRef as ReactComponent };